<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Dettagli</title>
    <path
      d="M11.952 16.914c-.192 0-.384-.073-.53-.22l-8.001-6a.75.75 0 1 1 1.061-1.061l7.47 5.47 7.47-5.47a.75.75 0 1 1 1.061 1.061l-8 6a.75.75 0 0 1-.53.22z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
